export var ClassNames;
(function (ClassNames) {
    ClassNames["modalOpened"] = "rj-modal-opened";
    ClassNames["modalOpenedFixed"] = "rj-modal-opened--fixed";
    ClassNames["isInIframe"] = "rj-modal-content-wrapper--isInIframe";
    ClassNames["hasOffSet"] = "rj-modal-content-wrapper--hasOffSet";
})(ClassNames || (ClassNames = {}));
//# sourceMappingURL=ClassNames.js.map